module.exports = __webpack_public_path__ + "img/haruna.c835abe1.jpeg";